export const getLinkUrlWithSlotId = (
    linkURL,
    slotId = 'cretio_zone' //eslint-disable-line
) => (slotId && linkURL ? linkURL.concat(`&rrplacementtype=${slotId}`) : linkURL);

export const fireBeacon = (action, beacon, triggerCriteoBeacon) => {
    const burl = beacon && beacon[action];
    burl && triggerCriteoBeacon({ url: burl });
};

export const fireClickBeacon = (e, location, { beacon }, linkUrl, triggerCriteoBeacon, slotId) => {
    e.preventDefault();

    fireBeacon('OnClickBeacon', beacon, triggerCriteoBeacon);

    !__SERVER__ &&
        window.setTimeout(() => {
            // eslint-disable-next-line no-param-reassign
            location.href = `${getLinkUrlWithSlotId(
                linkUrl,
                slotId
            )}&cm_re=Hooklogic-_-Hooklogic-_-Hooklogic`;
        }, 50);
};
